var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.parentStyle)},[_c('oss-image-view',{staticClass:"rounded-circle",style:(_vm.avatarStyle),attrs:{"img-path":_vm.user.avatar.path,"img-style":_vm.imgStyle}}),_c('img',{style:(_vm.frameStyle),attrs:{"src":_vm.frameImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }